/**
 * The tab identifiers used by RouteView (VF-4301).
 *
 * RouteView keeps the selected tab in the URL fragment so that a tab can be deep-linked - /route/5608347#rca opens
 * the route on its Root Cause tab - and pages which link into a particular tab reference these constants instead of
 * repeating the strings. The values are the hashes, minus the leading '#'.
 */
const RouteViewTabs = {
  LOCATIONS: 'locations',
  PRODUCTS: 'products',
  ROOT_CAUSE: 'rca',
  MANUAL_TEMPS: 'manual-temps',
  NOTES: 'notes',
  ROUTE_DATA: 'route-data',
  AUDIT_LOG: 'audit-log',
  NOTIFICATION_HISTORY: 'notification-history',
  DATA_QUALITY: 'data-quality'
}

export default Object.freeze(RouteViewTabs)
